import styled from 'styled-components';

import { COLOR } from 'assets/styles/colors';

export const Wrapper = styled.div`
  padding: 100px 15px;
  width: 100%;
  max-width: 942px;
  margin: 0 auto;

  p {
    margin: 1rem 0;
    text-align: justify;
  }

  h2 {
    color: ${COLOR.BLUE_1};
    position: relative;
    padding: 0 0 10px;
    margin-bottom: 25px;
    text-transform: initial;
    &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      width: 100px;
      height: 4px;
      background-color: ${COLOR.GREEN_1};
    }
  }

  /* Viewport <= 340px */
  @media screen and (max-width: 340px) {
    p {
      font-size: 14px;
    }
  }
`;
